module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-2.0322eac6.jpg";